import { cn } from "@/lib/cn";
import type { ReactNode } from "react";
import { TitlesStyled } from "../styles/Titles.styled";
import type { TabsPayload } from "../types";

export const Titles = ({
  entitiesLength,
  settings,
  children,
}: {
  entitiesLength: number;
  settings: TabsPayload;
  children: ReactNode;
}) => (
  <TitlesStyled
    {...STYLED_CONTAINER_ATTRIBUTES({ settings, total: entitiesLength })}
    className={cn("tabs-titles-container-zV6Fo4VZ5D tw-grid tw-gap-1", {
      "--hidden-icons": !settings.isShowTabsIcons,
      "tw-gap-0": ["design-1", "design-2"].includes(settings.tabsDesign),
      "tw-bg-[transparent]": ["design-2", "design-4"].includes(
        settings.tabsDesign,
      ),
      "tw-order-2": ["bottom", "right"].includes(settings.tabsLayout),
      "tw-w-[250px] tw-shrink-0 tw-grid-cols-1": ["left", "right"].includes(
        settings.tabsLayout,
      ),
      "tw-rounded-none tw-bg-[transparent]": settings.tabsDesign === "design-1",
      "tw-self-start":
        settings.tabsTitleslignment === "top" &&
        ["left", "right"].includes(settings.tabsLayout),
      "tw-self-end":
        settings.tabsTitleslignment === "bottom" &&
        ["left", "right"].includes(settings.tabsLayout),
    })}
  >
    {children}
  </TitlesStyled>
);

const STYLED_CONTAINER_ATTRIBUTES = ({
  settings,
  total,
}: {
  settings: TabsPayload;
  total: number;
}) => ({
  $background: settings.tabsBgColor,
  $rounded: settings.tabsBorderRadius,
  $row:
    settings.tabsPerRow === "auto" ? Math.min(total, 5) : settings.tabsPerRow,
  $design: settings.tabsDesign,
  $layout: settings.tabsLayout,
  $borderWidth: settings.tabsBorderWidth,
  $borderColor: settings.tabsBorderColor,
});
